import DownloadIcon from '@mui/icons-material/Download';
import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../../../constants/appRoutes";
import { buildLocalizeRoute } from "../../../../helpers/languageHelper";
import { Logout } from "../../../../services/authService";
import { SystemSettingsService } from "../../../../services/systemSettingsService";
import { DialogWrapper } from "../../../../shared/components/common/dialogWrapper";
import { ButtonWrapper } from "../../../../shared/components/formUtilities/useButton";
import { InvestorRegService } from "../../investor/investorRegService";
import { InvestorTermsAndCondition } from './termsCondition';
import { setURLParam } from '../../../../helpers/setParamUrlHelper';
import { trackOpenPanelView } from '../../../../helpers/openPanelHelper';
import { OpenPanelCategories, OpenPanelEvents } from '../../../../constants/openPanelEvents';
import { RegistrationURLSteps } from '../../../../constants/registrationURLStep';
import { LocalStorageKey } from '../../../../constants/localStorageKeys';

export const UserTermsConditionDialog = ({ state = '', onClose = () => { }, userType = 'investor' }) => {
  const systemSettingsService = new SystemSettingsService();
  const investorRegService = new InvestorRegService();
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [parentWidth, setParentWidth] = useState(0);
  const parentRef = useRef(null);
  const navigate = useNavigate();

  const settings = () => {
    return systemSettingsService.systemSettings();
  };

  const { t } = useTranslation();

  const getFile = () => {
    let url = settings()?.investorTermsAndConditions?.replace('http://', 'https://');
    return url;
  };

  useEffect(() => {
    // Function to update the width
    const updateWidth = () => {
      if (parentRef.current) {
        setParentWidth(parentRef.current.offsetWidth);
      }
    };

    // Initial measurement
    setTimeout(() => {
      updateWidth();
    }, 100);

    if (state) {
      setURLParam('currentStep', RegistrationURLSteps.termsCondition);
      if (userType === 'investor') {
        trackOpenPanelView(OpenPanelEvents.investorTermsViewed, {
          page_name: 'Investor terms',
          category: OpenPanelCategories.onboarding,
        });
      }
    }

    // Update the width on window resize
    window.addEventListener("resize", updateWidth);
    return () => {
      window.removeEventListener("resize", updateWidth);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const onHandleSubmit = () => {
    setLoadingSubmit(true);
    investorRegService
      .submitTermsCondition().then(resp => {
        localStorage.setItem(LocalStorageKey.isTermsDone, "1");
        setURLParam('currentStep', RegistrationURLSteps.investorType);
        setLoadingSubmit(false);
        onClose();
      }).catch(err => { setLoadingSubmit(false); });
  };

  const onHandleDecline = () => {
    Logout();
    navigate(`${buildLocalizeRoute(AppRoutes.Login)}`);
  };

  return <DialogWrapper
    maxWidth="md"
    preventOutsideClick
    hideCloseBtn
    dialogClass="relative t-c-dialog"
    dialogBodyClass="!justify-start"
    state={state}
    onClose={() => {
      onClose();
    }}
    title={t('termsConditionsInvestors')}
    actionFooterClass="!px-0"
    content={
      <Box className='relative w-full' ref={parentRef}>
        <Box className='flex justify-end cursor-pointer items-center mb-2' >
          <DownloadIcon color="primary" className="!text-[16px]" />
          <a href={getFile()} target='_blank' className='!text-[14px]' rel="noreferrer">{t('download')}</a>
        </Box>
        <Box className="flex flex-col space-y-6">
          <Box>
            <InvestorTermsAndCondition />
          </Box>
          <Box className='md:h-[20px] h-[55px]'>
            <Box className='fixed bottom-[32px] !py-[14px] bg-white flex md:justify-end md:flex-row flex-col justify-center items-center mt-6' sx={{ width: parentWidth }}>
              <Box
                className='flex justify-center items-center'>
                <ButtonWrapper classList='!bg-white' variant={'outlined'} disabled={loadingSubmit} onClick={() => {
                  onHandleDecline();
                }} label={t('notRightNow')}>
                </ButtonWrapper>
                <ButtonWrapper loading={loadingSubmit} classList="!mx-3" onClick={() => {
                  onHandleSubmit();
                }} label={t('iAgreeWithTerms')}>
                </ButtonWrapper>
              </Box>
            </Box>
          </Box>
        </Box >
      </Box >

    }
  ></DialogWrapper >;
};